'use strict';

/**
 * Initializes the slick slider for the PDP Zoom, sets initial slide based on PDP carousel selection
 */

var $pdpZoomCarousel = $('.js-zoom-carousel');

function adjustZoomCarousel() {
    $('body').on('click', '.js-zoom-button', function (e) {
        $('.js-carousel-item').removeClass('js-zoom-item');
        $(this).prevAll('.js-pdp-carousel').find('.slick-active .js-carousel-item').addClass('js-zoom-item');
    });

    $('body').on('hidden.bs.modal', '.js-pdp-carousel-modal', function () {
        // Destroy Zoom Slider, reset thumbnail state and aria attrs
        if ($pdpZoomCarousel.length) {
            $pdpZoomCarousel.slick('unslick');
            $('.js-zoom-thumbnails .js-slide-indicator').removeClass('active').attr('aria-current', 'false');
        }
    });

    $($pdpZoomCarousel).on('init afterChange lazyLoaded', function (e) {
        if ($(window).width() >= 1200) {
            const slideHeight = $('.js-zoom-carousel .slick-active .js-pdp-carousel__slider__item__img--zoom').height();
            const modalHeight = $('.js-pdp-img-zoom__body').height();
            const height = modalHeight > slideHeight ? modalHeight : slideHeight;
            $('.js-zoom-carousel, .js-pdp-img-zoom__item').height(height);
            let zoomUrl = $('.js-zoom-carousel .slick-active .js-pdp-carousel__slider__item__img--zoom').data('zoom-url');
            $('.js-zoom-image-link').attr('href', zoomUrl);

            $('.js-zoom-carousel .js-pdp-carousel__slider__item__img--zoom').each(function () {
                let alt = $(this).attr('alt');
                alt = `${alt} zoomed`;

                let parent = $(this).parent();
                let zoomImg = parent.find('.zoomImg');
                if (zoomImg.length) {
                    zoomImg.attr('alt', alt);
                }
            });
        }
    });

    //  On zoom modal show, determine which image should be set to active
    $('body').on('shown.bs.modal', '.js-pdp-carousel-modal', function () {
        const zoomSlideIndex = $('.js-zoom-item').length ? $('.js-zoom-item').data('carouselIndex') : '0';

        if ($pdpZoomCarousel.length) {
            $pdpZoomCarousel.not('.slick-initialized').slick({
                initialSlide: parseInt(zoomSlideIndex, 10)
            });
        }

        // detect thumbnail match and apply active state and aria current
        var $activeThumbnail = $('.js-zoom-thumbnails .c-carousel-zoom__thumbnails__item .js-slide-indicator').eq(zoomSlideIndex);
        $($activeThumbnail).addClass('active').attr('aria-current', 'true');

        $('.js-zoom-carousel .js-pdp-img-zoom__item').each(function () {
            let itemWithData = $(this).find('.js-pdp-carousel__slider__item__img--zoom');
            let zoomURL = itemWithData.data('zoom-url');
            let magnify = 1.5;

            if ($(window).width() >= 1200) {
                $(this).find('.zoomImg').remove();
                $(this).zoom(
                    {
                        url: zoomURL,
                        magnify: magnify,
                        on: 'click',
                        onZoomIn: function () {
                            $(this).addClass('zoomImg--zoomed');
                        },
                        onZoomOut: function () {
                            $(this).removeClass('zoomImg--zoomed');
                        }
                    });
            }
        });
    });
}

module.exports = {
    methods: {
        adjustZoomCarousel: adjustZoomCarousel
    },
    init() {
        const baseModule = this;
        let adjustZoomCarouselScoped = adjustZoomCarousel;

        if (baseModule && baseModule.methods && baseModule.methods.adjustZoomCarousel) {
            adjustZoomCarouselScoped = baseModule.methods.adjustZoomCarousel;
        }

        adjustZoomCarouselScoped();
    }
};
